var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-360",class:{'hide-footer-outer': _vm.hideFooter}},[(_vm.tsUserInfo)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }